module.exports = __webpack_public_path__ + "static/media/a4.a428e61b.png";